import config from 'configuration';
import { getToken } from './auth';

export const getFileUrl = (id) => `${config.apiUrl}/files/${id}?accessToken=${getToken()}`;
